import React from 'react';
import { CheckCircle } from 'lucide-react';
const CART_URL = 'https://www.tusoluciondigital.shop/cart/43130152714306:1';
export function SolutionSection() {
  return <section className="bg-white py-12 md:py-16 px-4" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-8 text-center" data-id="element-172">
          💖 "Hice esto para dejar de pensar en él en 7 días"
        </h2>

        <p className="text-xl md:text-2xl text-gray-800 mb-8 text-center font-semibold" data-id="element-173">
          Un sistema para:
        </p>

        <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-174">
          {['Cortar el apego', 'Dejar de sobrepensar', 'Recuperar tu energía mental', 'Volver a enfocarte en vos'].map((item, index) => <div key={index} className="flex items-start gap-3 bg-green-50 p-4 rounded-lg" data-id="element-175">
              <CheckCircle className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-176" />
              <span className="text-lg font-semibold text-gray-800" data-id="element-177">
                {item}
              </span>
            </div>)}
        </div>

        <div className="bg-purple-900 text-white rounded-lg p-8 md:p-12 mb-10" data-id="element-178">
          <div className="flex flex-col md:flex-row items-center justify-around gap-6 text-center" data-id="element-179">
            <div data-id="element-180">
              <div className="text-4xl mb-2" data-id="element-181">📂</div>
              <p className="font-bold text-lg" data-id="element-182">Leés el ebook</p>
            </div>
            <div className="hidden md:block text-3xl" data-id="element-183">→</div>
            <div data-id="element-184">
              <div className="text-4xl mb-2" data-id="element-185">🧠</div>
              <p className="font-bold text-lg" data-id="element-186">Aplicás los ejercicios</p>
            </div>
            <div className="hidden md:block text-3xl" data-id="element-187">→</div>
            <div data-id="element-188">
              <div className="text-4xl mb-2" data-id="element-189">💔</div>
              <p className="font-bold text-lg" data-id="element-190">Empiezas a soltar</p>
            </div>
          </div>
        </div>

        <p className="text-center text-xl font-bold text-gray-800 mb-8" data-id="element-191">
          Sin vueltas.
        </p>

        <div className="text-center" data-id="element-192">
          <a href={CART_URL} className="inline-block bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 uppercase" data-id="element-193">
            🔥 QUIERO RECUPERAR MI PAZ MENTAL HOY
          </a>
        </div>
      </div>
    </section>;
}